import React, { useState } from "react";
import "./ViewReportsHOD.css";
import axios from "axios";
import ViewReportsHODTable from "./ViewReportsHODTable.jsx";
// import ViewReportsHODForm from "./ViewReportsHODForm.jsx";
import ViewReportsHODFormEdit from "./ViewReportsHODFormEdit.jsx";
export default function ViewReportsHOD(props) {
  const [table, setTable] = useState(true);
  const [editForm, setEditForm] = useState(false);
  const [editData, setEditData] = useState({});
  const [SelectedEmp, setSelectedEmp] = useState([]);
  const handleAddViewReportsHOD = () => {
    // // console.log("clicked1");
    setTable(false);
  };
  const handleEditViewReportsHOD = (e) => {
    console.log(e);
    // console.log("clicked6");

    setEditForm(true);
    setEditData(e);
  };
  const handleFormClose = () => {
    // // console.log("clicked1");
    setTable(true);
  };
  const handleEditFormClose = () => {
    // console.log("clicked5");

    setEditForm(false);
  };

  const handleViewReportsHODEditUpdate = (info, newInfo, id) => {
    newInfo.preventDefault();

    let body = {
      Status: newInfo.target[4].value,
    };
    console.log("update", body);
    axios
      .put(
        "https://almawridems.javedahmadghamidi.com" +
          "/api/ems/leave-report-hod/" +
          id,
        body,
        {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        }
      )
      .then((res) => {
        setTable(false);
        setTable(true);
      })
      .catch((err) => {
        console.log(err);
      });
    setEditForm(false);
  };

  return (
    <React.Fragment>
      {table ? (
        editForm ? (
          <ViewReportsHODFormEdit
            onViewReportsHODEditUpdate={handleViewReportsHODEditUpdate}
            onFormEditClose={handleEditFormClose}
            editData={editData}
          />
        ) : (
          <ViewReportsHODTable
            onAddViewReportsHOD={handleAddViewReportsHOD}
            onEditViewReportsHOD={handleEditViewReportsHOD}
            data={props.data}
            SelectedEmp={SelectedEmp}
            setSelectedEmp={setSelectedEmp}
          />
        )
      ) : (
        <div></div>
      )}
    </React.Fragment>
  );
}
